import { Spinner } from "@fluentui/react-components";
import React from "react";

// ==============================|| LOADER ||============================== //
const Loader = ({ className="spinner-wrapper-dialog" }) => (
<div className="fixed top-0 left-0 w-full" style={{ zIndex: 99 }}>
  <div className={`${className}`}>
            <Spinner style={{ zIndex: '999999999' }} />
            </div>
    </div >
);

export default Loader;
